import Dropdown from './Dropdown';

const ButtonDropdown = (props) => {
  return (
    <Dropdown group {...props} />
  );
};

export default ButtonDropdown;



// WEBPACK FOOTER //
// ./src/ButtonDropdown.js